import styled from 'styled-components';
import Typography from '@spotnana/pixel-react/dist/Typography';

export const Title = styled(Typography).attrs({ variation: 'h3' })``;

export const ErrorMessage = styled(Typography).attrs({
  variation: 'body',
  color: 'text.label',
})``;
